module.exports = "https://coursera_assets.s3.amazonaws.com/images/67adb467b2690000b9fc3f35be0544d4.png";